module.exports = __webpack_public_path__ + "img/flowers8.d8f4b3ec.jpg";